import axios from 'axios';
import { getAuthHeader } from './authService';

const API_URL = process.env.REACT_APP_API_BASE_URL || '/api';

export interface TeamRequestDTO {
  id: number;
  teamId: number;
  teamName: string;
  studentId: number;
  studentName: string;
  studentEmail: string;
  schoolId: string;
  message: string;
  status: 'PENDING' | 'APPROVED' | 'DENIED';
  requestedAt: string;
  processedAt?: string;
  processedBy?: string;
  processorName?: string;
  teamDepartment?: string;
  teamMemberCount?: number;
}

export const teamRequestService = {
  async getPendingRequests(): Promise<TeamRequestDTO[]> {
    const response = await axios.get(`${API_URL}/team-requests/pending`, {
      headers: getAuthHeader()
    });
    return response.data;
  },

  async approveRequest(requestId: number): Promise<void> {
    await axios.post(`${API_URL}/team-requests/${requestId}/approve`, {}, {
      headers: getAuthHeader()
    });
  },

  async denyRequest(requestId: number): Promise<void> {
    await axios.post(`${API_URL}/team-requests/${requestId}/deny`, {}, {
      headers: getAuthHeader()
    });
  },

  async bulkApproveRequests(requestIds: number[]): Promise<void> {
    await axios.post(`${API_URL}/team-requests/bulk-approve`, requestIds, {
      headers: getAuthHeader()
    });
  },

  async bulkDenyRequests(requestIds: number[]): Promise<void> {
    await axios.post(`${API_URL}/team-requests/bulk-deny`, requestIds, {
      headers: getAuthHeader()
    });
  }
};